import React from 'react'
import Logincomp from '../../component/logincomp/Logincomp'

const Login = () => {
  return (
    <div>
      <Logincomp/>
    </div>
  )
}

export default Login
